'use client';

import React from 'react';
import { Archive, BadgeCheck } from 'lucide-react';
import { useTranslation } from '@/i18n/useTranslation';

const LEDGER1_ITEM_KEYS = [
  'landing_dual_model.ledger1_item1',
  'landing_dual_model.ledger1_item2',
  'landing_dual_model.ledger1_item3',
  'landing_dual_model.ledger1_item4',
];

const LEDGER2_ITEM_KEYS = [
  'landing_dual_model.ledger2_item1',
  'landing_dual_model.ledger2_item2',
  'landing_dual_model.ledger2_item3',
  'landing_dual_model.ledger2_item4',
];

export default function DualLedgerModelSection() {
  const { t } = useTranslation();
  return (
    <section
      id="dual-ledger"
      className="scroll-mt-24 py-20 sm:py-24"
      style={{ background: 'linear-gradient(180deg, #F8FAFC 0%, #EEF2FF 100%)' }}
    >
      <div className="mx-auto max-w-screen-2xl px-6 lg:px-10 2xl:px-16">
        <div className="mx-auto mb-14 max-w-3xl text-center">
          <p className="mb-3 text-xs font-black uppercase tracking-[0.22em] text-indigo-700">
            {t('landing_dual_model.title' as any)}
          </p>
          <h2 className="text-3xl font-black tracking-tight text-slate-950 sm:text-4xl">
            {t('landing_dual_model.subtitle' as any)}
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-slate-600">
            {t('landing_dual_model.body' as any)}
          </p>
        </div>

        <div className="grid gap-6 lg:grid-cols-2">
          <article className="rounded-3xl border border-teal-100 bg-white p-8 shadow-sm">
            <div className="mb-5 flex items-center gap-3">
              <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-teal-100 text-teal-700">
                <Archive size={22} />
              </div>
              <div>
                <p className="text-xs font-black uppercase tracking-wider text-teal-700">
                  {t('landing_dual_model.ledger1_title' as any)}
                </p>
                <h3 className="text-xl font-black text-slate-950">{t('landing_dual_model.ledger1_tag' as any)}</h3>
              </div>
            </div>
            <p className="text-sm leading-relaxed text-slate-600">
              {t('landing_dual_model.ledger1_desc' as any)}
            </p>
            <ul className="mt-5 space-y-2 text-sm font-semibold text-slate-700">
              {LEDGER1_ITEM_KEYS.map((key) => (
                <li key={key} className="flex items-start gap-2">
                  <span className="mt-1.5 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-teal-500" />
                  {t(key as any)}
                </li>
              ))}
            </ul>
          </article>

          <article className="rounded-3xl border border-violet-100 bg-white p-8 shadow-sm">
            <div className="mb-5 flex items-center gap-3">
              <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-violet-100 text-violet-700">
                <BadgeCheck size={22} />
              </div>
              <div>
                <p className="text-xs font-black uppercase tracking-wider text-violet-700">
                  {t('landing_dual_model.ledger2_title' as any)}
                </p>
                <h3 className="text-xl font-black text-slate-950">{t('landing_dual_model.ledger2_tag' as any)}</h3>
              </div>
            </div>
            <p className="text-sm leading-relaxed text-slate-600">
              {t('landing_dual_model.ledger2_desc' as any)}
            </p>
            <ul className="mt-5 space-y-2 text-sm font-semibold text-slate-700">
              {LEDGER2_ITEM_KEYS.map((key) => (
                <li key={key} className="flex items-start gap-2">
                  <span className="mt-1.5 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-violet-500" />
                  {t(key as any)}
                </li>
              ))}
            </ul>
          </article>
        </div>

        <p className="mx-auto mt-10 max-w-2xl text-center text-base font-semibold leading-relaxed text-slate-700">
          {t('landing_dual_model.together' as any)}
        </p>
      </div>
    </section>
  );
}
